import animation, { cubicBezierBackgroundColor } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  smallcapsBold13Styles,
  smallcapsRegular13Styles,
} from "@constants/typography"
import React from "react"
import styled from "styled-components"

const invertedProps = `
  ${smallcapsRegular13Styles}
  color: ${colors.black};
  background: none;

  @media ${breakpoints.laptop} {
    &:active {
      background: none;
    }
    &:hover {
      background: none;
    }
  }
`
export const Button = styled.button<{
  $inverted?: boolean
  disabled?: boolean
}>`
  ${smallcapsBold13Styles}
  display: flex;
  width: 100%;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: ${colors.offWhite};
  transition: background-color ${animation.medium} ${cubicBezierBackgroundColor};
  background-color: ${colors.black};
  border: none;
  border-radius: 2px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &:focus {
    outline: none;
  }

  &:active {
    background-color: ${colors.black};
  }

  @media ${breakpoints.laptop} {
    &:hover {
      background-color: ${colors.hoverBlack};
    }
  }

  ${({ $inverted }) => ($inverted ? invertedProps : "")}
`

export interface TextButtonProps
  extends React.PropsWithoutRef<JSX.IntrinsicElements["button"]> {
  className?: string
  inverted?: boolean
  text: string
}

const TextButton = React.forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ className, disabled, inverted, onClick, text, type = "button" }, ref) => (
    <Button
      $inverted={inverted}
      className={className}
      disabled={disabled}
      onClick={onClick}
      ref={ref}
      type={type}
    >
      {text}
    </Button>
  )
)

TextButton.displayName = "TextButton"

export default TextButton
